import { Box } from "@material-ui/core"
import { useCallback } from "react"
import type { ReactElement } from "react"
import { connect } from "react-redux"
import type { Dispatch } from "redux"

import { PageType, indexClearHistory, indexReturnToPage } from "../../../redux"
import type { Breadcrumb } from "../../../redux"
import { Caption, SubTitle1 } from "../../atoms"

import "./breadcrumb-item.styles.scss"
import { useTranslation } from "react-i18next"

export interface IBreadcrumbItemProps {
  page: Breadcrumb
  returnTo: (page: Breadcrumb) => void
}

export interface IBreadcrumbItemStateProps {
  returnToPage: (pageId: string) => void
  clearHistory: () => void
}

export function BreadcrumbItemView(props: IBreadcrumbItemProps & IBreadcrumbItemStateProps): ReactElement {
  const { page, returnTo, returnToPage, clearHistory } = props
  const { t } = useTranslation("indexPage")
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const getPageTypeName: () => string = useCallback<() => string>(() => {
    switch (page.type) {
      case PageType.Chapter:
        return t("chapter")
      case PageType.Region:
        return t("area")
      case PageType.Theme:
        return t("theme")
      case PageType.Index:
        return ""
    }
  }, [page.type])

  function onClick(): void {
    page.type === PageType.Index ? clearHistory() : returnToPage(page.id)
    returnTo(page)
  }

  return (
    <Box
      onClick={onClick}
      className="breadcrumb-item"
      data-mdat="referrer"
      data-mdat-item-id="breadcrumb-item"
      data-mdat-label={page.name}
      data-mdat-element-id={getPageTypeName().toLowerCase() === "" ? "root" : getPageTypeName().toLowerCase()}
    >
      <Box className="breadcrumb-item-name">
        <Caption>{getPageTypeName()}</Caption>
        <SubTitle1>{page.name}</SubTitle1>
      </Box>
    </Box>
  )
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    returnToPage: (pageId: string) => dispatch(indexReturnToPage(pageId)),
    clearHistory: () => dispatch(indexClearHistory())
  }
}

export const BreadcrumbItem = connect(undefined, mapDispatchToProps)(BreadcrumbItemView)
